import makeStyles from '@mui/styles/makeStyles'

const useInvestorGuaranteedgraphStyles = makeStyles({
  root: {},
})

export default useInvestorGuaranteedgraphStyles
